import { lazyRoute } from "@/routes/lazy-route";

const OfferingPage = lazyRoute(() => import("./offering.page"), "OfferingPage");
const OfferingDetailPage = lazyRoute(() => import("./offering-detail.page"), "OfferingDetailPage");

export const offeringRoutes = [
  { path: "offerings", element: <OfferingPage /> },
  { path: "offerings/:slug", element: <OfferingDetailPage /> },
];
